/**
 *
 * Header
 *
 */
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as PolkaIcon } from 'assets/images/polka-icon.svg';
// import { ReactComponent as PolkaLabel } from 'assets/images/polka-label.svg';
import { useTranslation } from 'react-i18next';
import { Button } from 'app/components';
import { useHistory } from 'react-router';
import { useSetRecoilState } from 'recoil';
import { useAddress } from 'utils/hooks/web3Hooks';
import { removeFromLocalStorage } from 'utils/services/LocalStorage';
import { redirectState } from 'store/app';
import { middleTruncate } from 'utils/helpers';

interface Props {}

export const Header = memo((props: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [address, setAddress] = useAddress();
  const setRedirectState = useSetRecoilState(redirectState);

  const connect = () => {
    setRedirectState(history.location);
    history.push('/connect');
  };

  const disconnect = () => {
    removeFromLocalStorage('wallet-connected');
    setAddress(null);
    history.push('/connect');
  };
  return (
    <div>
      <div className="w-full flex justify-between text-white">
        <div className="flex items-center gap-16">
          <Link to="/" className="logo flex items-center gap-2">
            <PolkaIcon />
            <span className="text-2xl font-medium">
              {t('appTitle', 'FiZen')}
            </span>
          </Link>
          <div className="nav-link flex gap-16">
            {address && (
              <Link to={`/owner/${address}`}>
                {t('yourVaults', 'Your loans')}
              </Link>
            )}

            <Link to="/loan/list">{t('openNewVaults', 'Open new loans')}</Link>
          </div>
        </div>
        <div className="hidden md:flex gap-3">
          <div className="nav-lang">
            <Button>En</Button>
          </div>
          <div className="nav-chain">
            <Button>DOT</Button>
          </div>
          <div className={`hidden xs:block`}>
            {!address ? (
              <Button onClick={connect}>
                {t('connectWallet', 'Connect wallet')}
              </Button>
            ) : (
              <Button color="active" onClick={disconnect}>
                {middleTruncate(address, 10)}
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className={`mt-5 md:hidden`}>
        <div className="nav-link flex gap-16">
          {address && (
            <Link to={`/owner/${address}`}>
              {t('yourVaults', 'Your loans')}
            </Link>
          )}
          <Link to="/loan/list">{t('openNewVaults', 'Open new loans')}</Link>
        </div>
      </div>
      <div className={`mt-5 w-full xs:hidden`}>
        {!address ? (
          <Button onClick={connect}>
            {t('connectWallet', 'Connect wallet')}
          </Button>
        ) : (
          <Button className={`w-full`} color="active" onClick={disconnect}>
            {middleTruncate(address, 30)}
          </Button>
        )}
      </div>
    </div>
  );
});
